import { PRODUCT_HOLDER_TYPES } from '@savgroup-front-common/constants';
import { safeFormattedIntlString } from '@savgroup-front-common/core/formatters';

import messages from './messages';

const getHolderType = (holderType: string): string => {
  switch (holderType?.toUpperCase()) {
    case PRODUCT_HOLDER_TYPES.OWNER.toUpperCase():
      return safeFormattedIntlString(messages.owner);
    case PRODUCT_HOLDER_TYPES.CARRIER.toUpperCase():
      return safeFormattedIntlString(messages.carrier);
    case PRODUCT_HOLDER_TYPES.REPAIRER_HUB.toUpperCase():
      return safeFormattedIntlString(messages.repairerHub);
    case PRODUCT_HOLDER_TYPES.REPAIRER_PARTNER.toUpperCase():
      return safeFormattedIntlString(messages.repairerPartner);
    case PRODUCT_HOLDER_TYPES.REPAIRER_WORKSHOP.toUpperCase():
      return safeFormattedIntlString(messages.repairerWorkshop);
    case PRODUCT_HOLDER_TYPES.STORE.toUpperCase():
      return safeFormattedIntlString(messages.store);
    case PRODUCT_HOLDER_TYPES.SUPPLIER.toUpperCase():
      return safeFormattedIntlString(messages.supplier);
    case PRODUCT_HOLDER_TYPES.EXTERNAL_CARRIER.toUpperCase():
      return safeFormattedIntlString(messages.externalCarrier);
    case PRODUCT_HOLDER_TYPES.WAREHOUSE.toUpperCase():
      return safeFormattedIntlString(messages.warehouse);
    default:
      return holderType;
  }
};

export default getHolderType;
